import React, { createContext, useContext, useState, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    localStorage.setItem('theme', mode);
    document.body.style.backgroundColor = mode === 'dark' ? '#121212' : '#f5f7fa';
  }, [mode]);

  const toggleTheme = () => setMode(prev => prev === 'light' ? 'dark' : 'light');

  const theme = createTheme({
    palette: {
      mode,
      primary: { main: '#0047AB', light: '#00A3FF', dark: '#003087' },
      secondary: { main: '#00A3FF' },
      background: {
        default: mode === 'dark' ? '#121212' : '#f5f7fa',
        paper: mode === 'dark' ? '#1e1e1e' : '#ffffff',
      },
    },
    typography: { fontFamily: 'Inter, sans-serif' },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 600 },
          containedPrimary: {
            background: 'linear-gradient(135deg, #0047AB 0%, #00A3FF 100%)',
            '&:hover': { background: 'linear-gradient(135deg, #003087 0%, #0080d4 100%)' }
          }
        }
      },
      MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
      MuiCard: { styleOverrides: { root: { borderRadius: 12 } } },
    }
  });

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export const useThemeContext = () => useContext(ThemeContext);
